<template>
  <WdsStack align-center gap-sm>
    {{ title }}
    <WdsTag
      v-if="count !== undefined && count !== null"
      sm
      :primary="!error"
      :error="error"
      subtle
      class="tw-rounded-full tw-px-2 tw-leading-none"
      data-test="tab-title-badge"
    >
      {{ count }}
    </WdsTag>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsStack, WdsTag } from '@worksome/wds-components'

// A tab title with a count pill beside it. The pill is red when something needs attention.
defineProps<{ title: string; count?: string | number | null; error?: boolean }>()
</script>
